<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const bgDesktopSrc = cfgToThemeCdnPath("/about-vip/modern/rakeboost-bg.png");
const bgMobileSrc = cfgToThemeCdnPath("/about-vip/modern/rakeboost-bg-mobile.png");
const bgSrc = $derived($isMobile ? bgMobileSrc : bgDesktopSrc);
const stepsSrc = cfgToThemeCdnPath("/about-vip/modern/rakeboost-steps.png");
</script>

<section class="vip-rakeboost">
	<img class="vip-rakeboost-bg" src={bgSrc} alt={$t(Verbiage.illustration_alt, 'alts')} />

	<div class="vip-rakeboost-header">
		<VipModernEyebrow text={$t(Verbiage.rakeboost)} />

		<Text
			type="title"
			titleSize="h4"
			titleWeight="bold"
			textColor="white"
			textAlign="center"
			className="vip-rakeboost-title"
		>
			{$t(Verbiage.vip_modern_rakeboost_title)}
		</Text>

		<Text
			type="body"
			bodySize="large"
			textColor="gray"
			textAlign="center"
			className="vip-rakeboost-body"
		>
			{$t(Verbiage.vip_modern_rakeboost_body)}
		</Text>
	</div>

	<InfoCard
		modernStyle
		modernGlowPosition="right"
		noPadding
		borderRadius="8px"
		customClass="vip-rakeboost-card"
	>
		<div class="vip-rakeboost-steps">
			<img
				class="vip-rakeboost-steps-img"
				src={stepsSrc}
				alt={$t(Verbiage.illustration_alt, 'alts')}
			/>
			<div class="vip-rakeboost-labels">
				<Text
					type="body"
					bodySize="small"
					bodyWeight="semibold"
					textColor="gray"
					textAlign="center"
					className="vip-rakeboost-label"
				>
					{$t(Verbiage.vip_modern_claim_reward)}
				</Text>
				<Text
					type="body"
					bodySize="small"
					bodyWeight="semibold"
					textColor="gray"
					textAlign="center"
					className="vip-rakeboost-label"
				>
					{$t(Verbiage.vip_modern_one_hour_boost)}
				</Text>
				<Text
					type="body"
					bodySize="small"
					bodyWeight="semibold"
					textColor="gray"
					textAlign="center"
					className="vip-rakeboost-label"
				>
					{$t(Verbiage.vip_modern_earn_more)}
				</Text>
			</div>
		</div>
	</InfoCard>
</section>

<style>
	.vip-rakeboost {

		position: relative;

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 1.25rem;

		overflow: hidden;

		padding-top: 3rem;

		padding-bottom: 3rem;

		padding-left: 1.5rem;

		padding-right: 1.5rem;

		text-align: center
}

	.vip-rakeboost-bg {

		position: absolute;

		top: 150px;

		right: 0px;

		z-index: 0;

		height: auto;

		width: 50%
}

	.vip-rakeboost-header {

		position: relative;

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 1.25rem
}

	:global(.vip-rakeboost-title) {

		font-size: 32px !important
}

	:global(.vip-rakeboost-body) {

		max-width: 50rem
}

	:global(.vip-rakeboost-card) {

		position: relative;

		margin-top: 1.5rem;

		width: 100%;

		max-width: 420px
}

	.vip-rakeboost-steps {

		display: flex;

		flex-direction: column;

		align-items: center;

		gap: 0.25rem;

		padding: 25px
}

	.vip-rakeboost-steps-img {

		height: auto;

		width: 100%;

		-o-object-fit: contain;

		   object-fit: contain
}

	.vip-rakeboost-labels {

		display: flex;

		width: 100%;

		align-items: flex-start;

		justify-content: space-between
}

	:global(.vip-rakeboost-label) {

		position: relative;

		right: 3px;

		max-width: 70px;

		text-align: center !important
}

	@media (min-width: 1024px) {
		:global(.vip-rakeboost-title) {

				font-size: 38px !important
		}

		.vip-rakeboost-bg {

				inset: 0px;

				height: 100%;

				width: 100%;

				-o-object-fit: cover;

				   object-fit: cover
		}

		.vip-rakeboost-labels {

				padding-left: 10px;

				padding-right: 10px
		}

		:global(.vip-rakeboost-label) {

				right: 0px
		}

		:global(.vip-rakeboost-label:nth-child(1)) {

				right: 6px
		}

		:global(.vip-rakeboost-label:nth-child(2)) {

				right: 6px
		}
	}
</style>
